import {createActiveRouterTabActions} from '@aviary/store/active-router-tab/active-router-tab.actions';
import {createActiveRouterTabSelectors} from '@aviary/store/active-router-tab/active-router-tab.selectors';
import {PaginationActions} from '@aviary/store/pagination/pagination.actions';
import {PaginationSelectors} from '@aviary/store/pagination/pagination.selectors';
import {QUERY_PARAMS_FEATURE_KEY} from '@aviary/store/query-params/query-params.types';
import {queryParamsState, QueryParamsState as BaseQueryParamsState} from '@aviary/store/query-params/query-params.state';
import {createQueryParamsActions} from '@aviary/store/query-params/query-params.actions';
import {createQueryParamsSelectors} from '@aviary/store/query-params/query-params.selectors';
import {createRouterSelectors} from '@aviary/store/router/router.selectors';
import {createRouterActions} from '@aviary/store/router/router.actions';
import {createSnackBarActions} from '@aviary/store/snack-bar/snack-bar.actions';
import {RouterLinkSnackBarConfig as BaseRouterLinkSnackBarConfig} from '@aviary/store/snack-bar/snack-bar.types';
import {CHILD_ROUTE_NAMES_FOR, ROUTER_TAB_INDEX_FOR, ROUTER_TABS_FOR} from '@app/app.routes';
import {RouteName} from '@app/app.route-names.generated';
import {
  ColumnDefinition as BaseColumnDefinition,
  LoadableSelectorContainer,
  RouteNameLinkColumnDefinition as BaseRouteNameLinkColumnDefinition,
  TableDefinition as BaseTableDefinition
} from '@aviary/components/table/table.component.types';
import {TableCardDefinition as BaseTableCardDefinition} from '@aviary/components/table-card/table-card.component.types';

// NOTE:  If you update this file, you should also update this app's .eslintrc.json to restrict imports from the proper parts of @aviary/store.

//
// Active Router Tab
//
export const ActiveRouterTabActions = createActiveRouterTabActions<RouteName>();
export const ActiveRouterTabSelectors = createActiveRouterTabSelectors<RouteName>(parentRouteName => ROUTER_TABS_FOR[parentRouteName]);

//
// Pagination
//
export {PaginationActions, PaginationSelectors};

//
// Query Params
//
export type QueryParamsState = BaseQueryParamsState<RouteName>;
export const QueryParamsActions = createQueryParamsActions<RouteName>();
export const QueryParamsSelectors = createQueryParamsSelectors<RouteName>();
export {QUERY_PARAMS_FEATURE_KEY, queryParamsState};

//
// Router
//
export const RouterActions = createRouterActions<RouteName>();
export const RouterSelectors = createRouterSelectors<RouteName>(routeName => CHILD_ROUTE_NAMES_FOR[routeName], routeName => ROUTER_TAB_INDEX_FOR[routeName]);

//
// Snack Bar
//
export type RouterLinkSnackBarConfig = BaseRouterLinkSnackBarConfig<RouteName>;
export const SnackBarActions = createSnackBarActions<RouteName>();

//
// Table
//
export type TableDefinition<ObjectType, DefaultSelectorContainer extends LoadableSelectorContainer> =
  BaseTableDefinition<ObjectType, DefaultSelectorContainer, RouteName>;

export type ColumnDefinition<ObjectType, DefaultSelectorContainer extends LoadableSelectorContainer> =
  BaseColumnDefinition<ObjectType, DefaultSelectorContainer, RouteName>;

export type RouteNameLinkColumnDefinition<ObjectType, DefaultSelectorContainer extends LoadableSelectorContainer> =
  BaseRouteNameLinkColumnDefinition<ObjectType, DefaultSelectorContainer, RouteName>;

//
// TableCard
//
export type TableCardDefinition<ObjectType, DefaultSelectorContainer extends LoadableSelectorContainer> =
  BaseTableCardDefinition<ObjectType, DefaultSelectorContainer, RouteName>;
